module.exports = __webpack_public_path__ + "static/img/samsung-svc-thumb.829f413.jpg";


//////////////////
// WEBPACK FOOTER
// ./static/img/project-detail/pjmove-thumbs/samsung-svc-thumb.jpg
// module id = CUvS
// module chunks = 0